export interface Bookmark {
  sectionId: string;
}

export function defaultBookmark(): Bookmark {
  return { sectionId: '' };
}
